module.exports = __webpack_public_path__ + "img/describe6.1fd7ec60.png";